<template>
  <v-autocomplete
      :error-messages="error"
      variant="outlined"
      rounded="0"
      :label="translation(translationList.leasing_company, 'Companie de leasing')"
      :items="leasingCompanies"
      item-title="name"
      item-value="id"
      :loading="loading"
      :disabled="loading"
      name="leasingCompany"
      v-model="selectedLeasingCompany"
      :rules="[v => !!v || translation(translationList.required, 'Acest câmp este obligatoriu')]"
      return-object
  >
  </v-autocomplete>
</template>

<script lang="ts">
import {defineComponent, ref, onMounted, watch, toRefs} from 'vue';
import { useRcaStore } from '~/plugins/store/rca';
import { useTranslationStore, translation } from '~/plugins/store/translations';
import type {LeasingCompany} from "~/types/Vehicle";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: {
      type: Object as () => LeasingCompany | null,
      default: () => null,
    },
  },
  emits: ['update:modelValue', 'validation-vehicle-status'],
  setup(props, { emit }) {
    const { modelValue } = toRefs(props);
    const rcaStore = useRcaStore();
    const translationStore = useTranslationStore();
    const selectedLeasingCompany = ref(props.modelValue);
    const leasingCompanies = ref<LeasingCompany[]>([]);
    const translationList = ref<TranslationList>({});
    const loading = ref(false);
    const error = ref([]);

    onMounted(async () => {
      loading.value = true;
      leasingCompanies.value = await rcaStore.getRcaLeasingCompanies();
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      loading.value = false;
      const isValid = !!selectedLeasingCompany.value;
      emit('validation-vehicle-status', { field: 'leasing_company', isValid });

      // Listen for validate event
      window.addEventListener('validate-vehicle', (data) => {
        if (data.detail && data.detail === 'leasing_company') {
          if (!selectedLeasingCompany.value) {
            error.value.push(translation(translationList.value.required, 'Acest câmp este obligatoriu'));
          } else {
            error.value = [];
            emit('validation-vehicle-status', { field: 'leasing_company', isValid: true });
          }
        }
      });
    });

    watch(selectedLeasingCompany, (newValue) => {
      error.value = [];
      emit('update:modelValue', newValue);
    });

    watch(modelValue, (newValue) => {
      if (newValue) {
        selectedLeasingCompany.value = newValue;
      }
      const isValid = !!newValue;
      emit('validation-vehicle-status', { field: 'leasing_company', isValid });
    });

    return {
      selectedLeasingCompany,
      leasingCompanies,
      translationList,
      translation,
      loading,
      error,
    };
  },
});
</script>

<style scoped>
</style>
